import CookieBannerView from './CookieBannerView'


export default CookieBannerView
